export default {
  default: {
    // Admin variants - SidePanel variants have been moved to aldoo-ra/SidePanel/variants.jsx
  },
}